import { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Paper,
  Autocomplete,
  Chip,
  Stack,
  Grid,
} from "@mui/material";
import CommonDialog from "../../../components/CommonDialog";
import FormLabel from "../../../components/FormLabel";

const EditToolsModal = (props) => {
  // modal states
  const [localData, setLocalData] = useState([]);

  // other functions
  const handleSubmit = () => {
    props.setOpen({ ...props.open, editTools: false });
    props.setEmployeeData({ ...props.employeeData, tools: localData });
  };

  const handleToolNameChange = (data) => {
    const tools = data.map((tool) => ({
      name: tool.name,
      value: tool?.value ?? 75,
    }));
    setLocalData(tools);
  };

  useEffect(() => {
    setLocalData([...props.employeeData?.tools]);
    // eslint-disable-next-line
  }, []);

  return (
    <CommonDialog
      open={true}
      title={props.title || "Edit Tools"}
      onSubmit={handleSubmit}
      onClose={() => props.setOpen({ ...props.open, editTools: false })}
    >
      <Paper style={{ ...props.style, width: "100%" }} elevation={0}>
        <Box sx={{ padding: "10px" }}>
          <Stack spacing={1}>
            <Grid container alignItems={"end"}>
              <Grid xs={12} sm={12} md={12} lg={12} xl={12} item>
                <FormLabel title="Tools & Technology" />
                <Autocomplete
                  variant="outlined"
                  size="small"
                  multiple={true}
                  sx={{ width: "100%" }}
                  value={localData}
                  renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                      <Chip
                        sx={{ fontWeight: "500" }}
                        label={option.name}
                        {...getTagProps({ index })}
                        disabled={localData.length <= 1}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // label="Tools & tech"
                      placeholder="Select Tools & Technology"
                    />
                  )}
                  options={props.toolsList}
                  getOptionLabel={(option) => option.name}
                  isOptionEqualToValue={(option, value) =>
                    option.name === value.name
                  }
                  onChange={(_, value) => handleToolNameChange(value)}
                />
              </Grid>
            </Grid>
          </Stack>
        </Box>
      </Paper>
    </CommonDialog>
  );
};

export default EditToolsModal;
